import * as ActionTypes from '../constants/actionTypes'
import { login } from './app'
import api from '../utils/api'

export const changeFormFields = formFieldsChange => ({
  type: ActionTypes.LOGIN_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const resetMfa = () => ({
  type: ActionTypes.LOGIN_MFA_RESET,
})

export const sendLoginRequest = values => async (dispatch) => {
  dispatch({ type: ActionTypes.LOGIN_LOGIN_LOAD })
  const params = {
    ...values,
    strategy: 'local',
  }
  try {
    const result = await api.login(params)
    
    // Check if MFA is required
    if (result.mfa_required) {
      dispatch({
        type: ActionTypes.LOGIN_MFA_REQUIRED,
        mfaType: result.mfa_type,
        userId: result.user_id,
        email: values.email,
        password: values.password,
      })
      return
    }
    
    dispatch({ type: ActionTypes.LOGIN_LOGIN_SUCCEED })
    dispatch(login({ accessToken: result.accessToken }))
  } catch (error) {
    dispatch({
      type: ActionTypes.LOGIN_LOGIN_FAIL,
      loginError: error.message,
    })
  }
}

export const sendMfaVerification = (totpCode) => async (dispatch, getState) => {
  dispatch({ type: ActionTypes.LOGIN_LOGIN_LOAD })
  const { login: loginState } = getState()
  const params = {
    email: loginState.mfaEmail,
    password: loginState.mfaPassword,
    totp_code: totpCode,
    strategy: 'local',
  }
  try {
    const result = await api.login(params)
    dispatch({ type: ActionTypes.LOGIN_LOGIN_SUCCEED })
    dispatch(login({ accessToken: result.accessToken }))
  } catch (error) {
    dispatch({
      type: ActionTypes.LOGIN_LOGIN_FAIL,
      loginError: error.message,
    })
  }
}

export const loginWithPasskey = (email) => async (dispatch) => {
  dispatch({ type: ActionTypes.LOGIN_LOGIN_LOAD })
  try {
    // Get authentication options
    const options = await api.call('passkeys/authentication-options', { email }, 'POST')
    
    // Start WebAuthn authentication
    const { startAuthentication } = await import('@simplewebauthn/browser')
    const credential = await startAuthentication(options)
    
    // Verify with server
    const result = await api.call('authentication/passkey', { email, credential }, 'POST')
    
    dispatch({ type: ActionTypes.LOGIN_LOGIN_SUCCEED })
    dispatch(login({ accessToken: result.accessToken }))
  } catch (error) {
    dispatch({
      type: ActionTypes.LOGIN_LOGIN_FAIL,
      loginError: error.message || 'Passkey authentication failed',
    })
  }
}
